<template>
  <b-row class="mc-dashboard__widget-summarytrip">
    <b-col md="3" class="mb-4">
      <TotalSummaryFleetSection
        :loaded="loaded"
        :title="$t('dashboard.title.totalDistance')"
        :tooltip="$t('dashboard.summary.tooltip.totalDistance')"
        :total-vehicle="datas?.utilizedVehicle?.chosenValue"
        :percentage="datas?.tripMileage.diffPercent"
        :is-increased="datas?.tripMileage.increased"
        :datas="[
          {
            value: datas?.tripMileage.chosenValue,
            unit: $t('global.unit.kilometers'),
          },
        ]"
        :textPos="$t('maintenance.farther')"
        :textNeg="$t('maintenance.closer')"
      />
    </b-col>
    <b-col md="3" class="mb-4">
      <TotalSummaryFleetSection
        :loaded="loaded"
        :title="$t('dashboard.title.totalTrip')"
        :tooltip="$t('dashboard.summary.tooltip.totalTrip')"
        :total-vehicle="datas?.utilizedVehicle?.chosenValue"
        :percentage="datas?.totalTrip.diffPercent"
        :is-increased="datas?.totalTrip.increased"
        :datas="[
          {
            value: datas?.totalTrip.chosenValue,
            unit: $t('global.object.trip'),
          },
        ]"
        :textPos="$t('maintenance.lots')"
        :textNeg="$t('maintenance.little')"
      />
    </b-col>
    <b-col md="3" class="mb-4">
      <TotalSummaryFleetSection
        :loaded="loaded"
        :title="$t('dashboard.title.averageSpeed')"
        :tooltip="$t('dashboard.summary.tooltip.averageSpeed')"
        :total-vehicle="datas?.utilizedVehicle?.chosenValue"
        :percentage="datas?.avgSpeed.diffPercent"
        :is-increased="!datas?.avgSpeed.increased"
        :datas="[
          {
            value: datas?.avgSpeed.chosenValue,
            unit: $t('global.unit.kmPerHour'),
          },
        ]"
        :textPos="$t('maintenance.slower')"
        :textNeg="$t('maintenance.faster')"
      />
    </b-col>
    <b-col md="3" class="mb-4">
      <TotalSummaryFleetSection
        :loaded="loaded"
        :title="$t('dashboard.title.totalFuel')"
        :tooltip="$t('dashboard.summary.tooltip.totalFuel')"
        :total-vehicle="datas?.utilizedVehicle?.chosenValue"
        :percentage="datas?.fuelConsumption.diffPercent"
        :is-increased="!datas?.fuelConsumption.increased"
        :datas="[
          {
            value: datas?.fuelConsumption.chosenValue,
            unit: $t('global.unit.liter'),
          },
        ]"
        :textPos="$t('maintenance.moreEfficient')"
        :textNeg="$t('maintenance.moreWasteful')"
      />
    </b-col>
    <b-col md="3">
      <TotalSummaryFleetSection
        :loaded="loaded"
        :title="$t('dashboard.title.efficiencyAverage')"
        :tooltip="$t('dashboard.summary.tooltip.efficiencyAverage')"
        :total-vehicle="datas?.utilizedVehicle?.chosenValue"
        :percentage="datas?.fuelEfficiency.diffPercent"
        :is-increased="!datas?.fuelEfficiency.increased"
        :datas="[
          {
            value: datas?.fuelEfficiency.chosenValue,
            unit: $t('global.unit.kmPerLiter'),
          },
        ]"
        :textPos="$t('maintenance.moreEfficient')"
        :textNeg="$t('maintenance.moreWasteful')"
      />
    </b-col>
    <b-col md="3">
      <TotalSummaryFleetSection
        :loaded="loaded"
        :title="$t('dashboard.title.fuelCost')"
        :tooltip="$t('dashboard.summary.tooltip.fuelCost')"
        :total-vehicle="datas?.utilizedVehicle?.chosenValue"
        :percentage="datas?.fuelPrice.diffPercent"
        :is-increased="!datas?.fuelPrice.increased"
        :datas="[
          {
            value: datas?.fuelPrice.chosenValue / datas?.tripMileage.chosenValue,
            unit: $t('global.unit.rpPerKm'),
          },
        ]"
        :textPos="$t('maintenance.cheaper')"
        :textNeg="$t('maintenance.moreExpensive')"
      />
    </b-col>
    <b-col md="3">
      <TotalSummaryFleetSection
        :loaded="loaded"
        :title="$t('dashboard.title.totalEngineOn')"
        :tooltip="$t('dashboard.summary.tooltip.totalEngineOn')"
        :total-vehicle="datas?.utilizedVehicle?.chosenValue"
        :percentage="datas?.engineOnDuration.diffPercent"
        :is-increased="!datas?.engineOnDuration.increased"
        :datas="[
          {
            value: Math.floor(datas?.engineOnDuration.chosenValue / 3600),
            unit: $t('global.time.hours'),
          },
          {
            value: Math.floor((datas?.engineOnDuration.chosenValue % 3600) / 60),
            unit: $t('global.time.minutes'),
          },
        ]"
        :textPos="$t('maintenance.shorter')"
        :textNeg="$t('maintenance.longer')"
      />
    </b-col>
    <b-col md="3">
      <TotalSummaryFleetSection
        :loaded="loaded"
        :title="$t('dashboard.title.totalIdle')"
        :tooltip="$t('dashboard.summary.tooltip.totalIdle')"
        :total-vehicle="datas?.utilizedVehicle?.chosenValue"
        :percentage="datas?.idleDuration.diffPercent"
        :is-increased="!datas?.idleDuration.increased"
        :datas="[
          {
            value: Math.floor(datas?.idleDuration.chosenValue / 3600),
            unit: $t('global.time.hours'),
          },
          {
            value: Math.floor((datas?.idleDuration.chosenValue % 3600) / 60),
            unit: $t('global.time.minutes'),
          },
        ]"
        :textPos="$t('maintenance.shorter')"
        :textNeg="$t('maintenance.longer')"
      />
    </b-col>
  </b-row>
</template>
<script>
import TotalSummaryFleetSection from './TotalSummaryFleetSection.vue'
import { Helper } from '@/mixin/helper'

export default {
  components: {
    TotalSummaryFleetSection,
  },
  mixins: [Helper],
  props: {
    datas: {
      type: Object,
      default: null,
    },
    fleetTypes: {
      type: Array,
      default: () => [],
    },
    loaded: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
